// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.AdminLayout-sideMenuContainer-ZFv9K {
    display: block;
}

.AdminLayout-sideMenuWrapper-Hy0Lr {
    position: fixed;
    top: 0;
    left: 0;
    bottom: 0;
    width: 100%;
    height: 100%;
    min-width: var(--sideMenu-width);
    max-width: var(--sideMenu-width);
    background: var(--sideMenu-primary);
    display: -webkit-box;
    display: -ms-flexbox;
    display: flex;
    z-index: 1030;
}

.AdminLayout-mainContent-jOf4F {
    margin-left: var(--sideMenu-width);
    height: 100%;
    position: relative;
    padding: calc(var(--sideMenu-header-height) + 24px) 24px 120px;
}

a,
a:hover,
a:focus,
a:active {
    color: var(--primary-link-foreground);
    text-decoration: unset;
}

@media (max-width: 1199px) {
    .AdminLayout-sideMenuContainer-ZFv9K {
        display: none;
    }

    .AdminLayout-mainContent-jOf4F {
        margin-left: 0;
    }
}`, "",{"version":3,"sources":["webpack://./src/components/Layout/AdminLayout.css"],"names":[],"mappings":"AAAA;IACI,cAAc;AAClB;;AAEA;IACI,eAAe;IACf,MAAM;IACN,OAAO;IACP,SAAS;IACT,WAAW;IACX,YAAY;IACZ,gCAAgC;IAChC,gCAAgC;IAChC,mCAAmC;IACnC,oBAAa;IAAb,oBAAa;IAAb,aAAa;IACb,aAAa;AACjB;;AAEA;IACI,kCAAkC;IAClC,YAAY;IACZ,kBAAkB;IAClB,8DAA8D;AAClE;;AAEA;;;;IAII,qCAAqC;IACrC,sBAAsB;AAC1B;;AAEA;IACI;QACI,aAAa;IACjB;;IAEA;QACI,cAAc;IAClB;AACJ","sourcesContent":[".sideMenuContainer {\n    display: block;\n}\n\n.sideMenuWrapper {\n    position: fixed;\n    top: 0;\n    left: 0;\n    bottom: 0;\n    width: 100%;\n    height: 100%;\n    min-width: var(--sideMenu-width);\n    max-width: var(--sideMenu-width);\n    background: var(--sideMenu-primary);\n    display: flex;\n    z-index: 1030;\n}\n\n.mainContent {\n    margin-left: var(--sideMenu-width);\n    height: 100%;\n    position: relative;\n    padding: calc(var(--sideMenu-header-height) + 24px) 24px 120px;\n}\n\na,\na:hover,\na:focus,\na:active {\n    color: var(--primary-link-foreground);\n    text-decoration: unset;\n}\n\n@media (max-width: 1199px) {\n    .sideMenuContainer {\n        display: none;\n    }\n\n    .mainContent {\n        margin-left: 0;\n    }\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"sideMenuContainer": `AdminLayout-sideMenuContainer-ZFv9K`,
	"sideMenuWrapper": `AdminLayout-sideMenuWrapper-Hy0Lr`,
	"mainContent": `AdminLayout-mainContent-jOf4F`
};
module.exports = ___CSS_LOADER_EXPORT___;
